import React from "react";
import moment from "moment";

import "../styles/GlobalFooter.css";

const currentYear = `${moment().year()}`;

const GlobalFooter = () => {
	return (
		<footer>
			<div className="group">
				<div className="footer-tagline">
					<span>
						<span />
					</span>
				</div>
			</div>
			<div className="group">
				<div className="footer-statement">
					<div className="title">Our Mission Is Simple.</div>
					Help clients around the world achieve their long-term investment
					goals.
				</div>
				<div className="footer-links js-social-icons js-rem-ous">
					<ul className="social-icons">
						<li className="title">Connect with us:</li>
						<li>
							<a
								className="fb"
								href="http://www.facebook.com/troweprice"
								title="Facebook"
								alt="Facebook"
								target="_blank"
								rel="noopener noreferrer"
							>
								Facebook
							</a>
						</li>
						<li>
							<a
								className="tw"
								href="https://twitter.com/troweprice"
								title="Twitter"
								alt="Twitter"
								target="_blank"
								rel="noopener noreferrer"
							>
								Twitter
							</a>
						</li>
						<li>
							<a
								className="yt"
								href="http://www.youtube.com/trowepricegroup"
								title="YouTube"
								alt="YouTube"
								target="_blank"
								rel="noopener noreferrer"
							>
								YouTube
							</a>
						</li>
						<li>
							<a
								className="ln"
								href="http://www.linkedin.com/company/157329?trk=tyah"
								title="LinkedIn"
								alt="LinkedIn"
								target="_blank"
								rel="noopener noreferrer"
							>
								LinkedIn
							</a>
						</li>
					</ul>
				</div>
				<div className="footer-links">
					<ul className="footer-links-list">
						<li>
							<a href="https://www.troweprice.com/corporate/en/what-we-do.html">
								Company Overview
							</a>
						</li>
						<li>
							<a href="https://www.troweprice.com/corporate/en/what-sets-us-apart/corporate-responsibility.html">
								Responsibility
							</a>
						</li>
						<li>
							<a href="https://www.troweprice.com/corporate/en/careers.html">
								Careers
							</a>
						</li>
						<li>
							<a href="https://troweprice.gcs-web.com/">Investor Relations</a>
						</li>
						<li>
							<a href="https://www.troweprice.com/corporate/en/press.html">
								Press Releases
							</a>
						</li>
					</ul>
				</div>
				<div className="footer-links">
					<ul className="footer-links-list">
						<li>
							<a href="https://www.troweprice.com/personal-investing/sitemap.html">
								Site Map
							</a>
						</li>
						<li>
							<a href="https://www.troweprice.com/personal-investing/help/policies-and-security/privacy.html">
								Privacy Policy
							</a>
						</li>
						<li>
							<a href="https://www.troweprice.com/personal-investing/help/terms-of-use.html">
								Terms of Use
							</a>
						</li>
						<li>
							<a href="https://www.troweprice.com/personal-investing/help/policies-and-security/security.html">
								Security Measures
							</a>
						</li>
						<li>
							<a href="https://www.troweprice.com/personal-investing/help/policies-and-security/legal-information.html">
								Legal Information
							</a>
						</li>
						<li>
							<a href="https://www.troweprice.com/personal-investing/help/policies-and-security/customer-agreement.html">
								Customer Agreement
							</a>
						</li>
					</ul>
				</div>
				<div className="footer-links">
					<ul className="footer-links-list">
						<li>
							<a href="https://www.troweprice.com/corporate/en/mobile-solutions.html">
								Mobile Solutions
							</a>
						</li>
						<li>
							<a href="https://www.troweprice.com/personal-investing/help/contact-us.html">
								Contact Us
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div>
				The mutual funds referred to in this website are offered and sold only
				to persons residing in the United States and are offered by prospectus
				only. The prospectuses include investment objectives, risks, fees,
				expenses, and other information that you should read and consider
				carefully before investing.
				<br />
				<a href="https://www.troweprice.com/personal-investing/mutual-funds/prospectuses-reports.html">
					Download a prospectus
				</a>
				.
				<br />
				<br />©{currentYear}. All Rights Reserved. T.&nbsp;Rowe&nbsp;Price
				Investment Services, Inc., distributor, T.&nbsp;Rowe&nbsp;Price mutual
				funds. T.&nbsp;ROWE&nbsp;PRICE, INVEST WITH CONFIDENCE, and the bighorn
				sheep design are trademarks of T.&nbsp;Rowe&nbsp;Price Group, Inc. All
				other trademarks are the property of their respective owners.
			</div>
		</footer>
	);
};

export default GlobalFooter;
